module.exports = __webpack_public_path__ + "img/Avatar-7.39330e6c.gif";